import { render, staticRenderFns } from "./NewProcedureDirectoryDialog.vue?vue&type=template&id=65353fec&"
import script from "./NewProcedureDirectoryDialog.vue?vue&type=script&lang=js&"
export * from "./NewProcedureDirectoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProcedureDirectoryDialog.vue"
export default component.exports